import _ from 'lodash'
import { useContext, useMemo } from 'react'
import { SwiperSlide } from 'swiper/react'

import { PageAreaContext } from 'global/cnr/contexts/PageAreaContext'
import { gEnums } from 'global/enums/globalEnums'

import { uniqueKey } from 'global/common/keys'
import PageItem from 'global/page/PageItem'
import { Swiper_Any } from './Swiper_Any'
import { _swiperMenuTypes } from './SwiperMenu'
import { sortObj } from 'global/common/sorting'
import { ParentContext } from 'global/cnr/contexts/ParentContext'

export const Swiper_PageArea = ({
  swipeContentType,
  swiperMenuType = _swiperMenuTypes.menu,
  isChild = false,
  applyFade = false,
}) => {


  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {};
  const { paps_state, appUser_state } = states ?? {};
  const { viewPathKey } = paps_state ?? {};

  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown } = pageArea_state ?? {}

  const slides = useMemo(() => {
    if (swipeContentType !== gEnums.swipeContentTypes.pageAreaContent || _.isEmpty(pageItemsShown)) return []

    const sorted = _.sortBy(pageItemsShown, 'position')

    return _.map(sorted, (csi, csiKey, idx) => (
      <SwiperSlide
        key={uniqueKey('sipi', csi.key)}
        className={`sst-${csi.key}`}>
        <PageItem
          uivi={csi.key}
          tabIndex={idx}
          returnCount={true}
          from="aaa"
          inSwiper={true}
          isMounted={true} // or lazy logic here
        />
      </SwiperSlide>
    ))
  }, [pageItemsShown, swipeContentType])

  return (
    <Swiper_Any
      swKey={viewPathKey}
      menuItems={pageItemsShown}
      swipeContentType={swipeContentType}
      swiperMenuType={swiperMenuType}
      isChild={false}
      applyFade={applyFade}
      slides={slides}
    />

  )
}